import { stringify } from 'querystring';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { CloudId, IssueTypeId, ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { WorkflowCapabilities } from '@atlassian/jira-project-settings-common-workflow-types/src/types.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';

export const getApiPrefix = () => 'gateway/api/jira/project-configuration';

export type Params =
	| {
			workflowId: string;
	  }
	| {
			projectId: ProjectId;
			issueTypeId: IssueTypeId;
	  };

export const constructEndpoint = (cloudId: CloudId, params: Params) =>
	`/${getApiPrefix()}/query/${cloudId}/workflow/capabilities?${stringify(params)}`;

export const getWorkflowCapabilities = (
	cloudId: CloudId,
	options: Params,
): Promise<WorkflowCapabilities> =>
	fetchJson(constructEndpoint(cloudId, options), {
		method: 'GET',
	}).catch((e) => {
		log.safeErrorWithoutCustomerData('getWorkflowAvailableCapabilities', e);
		throw e;
	});
